import React from "react";
import { X } from "lucide-react";

export default function StudentEditModalHeader({
  iconSrc,
  title,
  onMouseDown,
  onClose,
}) {
  return (
    <div
      className="flex justify-between items-center px-8 pt-8 pb-4 border-b border-gray-100 z-20 shrink-0 cursor-move bg-[#FCFCFD]"
      onMouseDown={onMouseDown}
    >
      <h3 className="text-3xl font-black text-[#2C3E30] flex items-center gap-3 font-do-hyeon">
        <img src={iconSrc} width={40} alt="icon" /> {title}
      </h3>
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600 bg-gray-100 p-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <X size={24} />
      </button>
    </div>
  );
}
